/* eslint-disable no-mixed-operators */
/* eslint-disable max-len */
import React, { useState, useRef } from 'react'
import domtoimage from 'dom-to-image-more'
import {
  Row, Col, Button, Steps, Popover, Tooltip,
} from 'antd'
import Icon, {
  PictureOutlined, UndoOutlined, InfoCircleOutlined, LeftOutlined, RightOutlined,
  SaveOutlined, FolderOpenOutlined,
} from '@ant-design/icons'

import { useScroll } from 'ahooks'
// import html2canvas from 'html2canvas'
import { GASSIEN_COLOR } from '../../static/colors'


import { formatPrice } from '../../engine/prices'
import track from '../../engine/tracking'


import BoxModal from '../elements/BoxModal'
import CalculatorModal from '../elements/CalculatorModal'

import {
  StyleInfos, WallBasesInfos, BoardsInfos, AccessoriesInfos, DecorInfos,
} from './StepsInfos'

import GridSvg from '../svg/grid'
import Hooks from '../svg/hooks'
import Board from '../svg/board'
import VaseZenith from '../svg/vaseZenith'
import Empty from '../svg/empty'

import { useIsSmallDevice } from '../../hookreducer/hooks'


import __ from '../../languages/parser'


const { Step } = Steps


// Méthode compatible tous navigateurs (définie en premier)
const saveWithLegacyMethod = (blob, fileName) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${fileName}.png`

  // Important pour WordPress et Chrome
  link.style.display = 'none'
  document.body.appendChild(link)

  // Déclenchement avec timeout pour WordPress
  setTimeout(() => {
    link.click()

    // Nettoyage après téléchargement
    setTimeout(() => {
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }, 100)
  }, 0)
}

// Méthode moderne (optionnelle mais plus fiable)
const saveWithFileSystemAPI = async (blob, fileName) => {
  try {
    const handle = await window.showSaveFilePicker({
      suggestedName: `${fileName}.png`,
      types: [{
        description: 'Image PNG',
        accept: { 'image/png': ['.png'] },
      }],
    })
    const writable = await handle.createWritable()
    await writable.write(blob)
    await writable.close()
  } catch (err) {
    if (err.name !== 'AbortError') {
      console.error('Erreur saveFilePicker:', err)
      saveWithLegacyMethod(blob, fileName) // Fallback
    }
  }
}

const saveAsPng = async (fileName = 'Gassien-composition') => {
  const whiteboard = document.getElementById('whiteboard')

  if (!whiteboard) {
    console.error('Element #whiteboard non trouvé')
    return
  }

  console.log('=== SAUVEGARDE PNG ===')

  try {
    const scale = 4
    const rect = whiteboard.getBoundingClientRect()

    console.log('Génération canvas...')

    const canvas = await domtoimage.toCanvas(whiteboard, {
      quality: 1.0,
      width: rect.width * scale,
      height: rect.height * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: `${rect.width}px`,
        height: `${rect.height}px`,
      },
      cacheBust: true,
      imagePlaceholder: undefined,
    })

    console.log('Canvas généré:', canvas.width, 'x', canvas.height)

    // ===== CROP BASÉ DOM =====
    console.log('Crop basé DOM en cours...')

    // Ajouter une marge en pixels (définie ici)
    const marginPx = 50

    // Récupérer tous les éléments enfants visibles
    const allElements = whiteboard.querySelectorAll('*')
    const whiteboardRect = whiteboard.getBoundingClientRect()

    let minX = Infinity
    let minY = Infinity
    let maxX = -Infinity
    let maxY = -Infinity
    let foundElements = false

    console.log('[Crop DOM] Analyse de', allElements.length, 'éléments...')

    allElements.forEach((element) => {
      const elementRect = element.getBoundingClientRect()

      // Ignorer les éléments invisibles ou trop petits
      if (elementRect.width <= 1 || elementRect.height <= 1) {
        return
      }

      // Calculer position relative au whiteboard
      const left = elementRect.left - whiteboardRect.left
      const top = elementRect.top - whiteboardRect.top
      const right = left + elementRect.width
      const bottom = top + elementRect.height

      // Vérifier si l'élément est visible (a du contenu)
      const style = window.getComputedStyle(element)
      const isVisible = style.display !== 'none'
                       && style.visibility !== 'hidden'
                       && style.opacity !== '0'

      if (isVisible && elementRect.width > 5 && elementRect.height > 5) {
        foundElements = true

        if (left < minX) minX = left
        if (top < minY) minY = top
        if (right > maxX) maxX = right
        if (bottom > maxY) maxY = bottom
      }
    })

    let croppedCanvas = canvas

    if (foundElements) {
      console.log('[Crop DOM] Bounds trouvés:', {
        minX: minX.toFixed(0),
        minY: minY.toFixed(0),
        maxX: maxX.toFixed(0),
        maxY: maxY.toFixed(0),
      })

      const bounds = {
        x: Math.max(0, (minX - marginPx) * scale),
        y: Math.max(0, (minY - marginPx) * scale),
        width: (maxX - minX + marginPx * 2) * scale,
        height: (maxY - minY + marginPx * 2) * scale,
      }

      console.log('[Crop DOM] Bounds finaux:', bounds)
      console.log('[Crop DOM] Réduction:',
        ((1 - (bounds.width * bounds.height) / (canvas.width * canvas.height)) * 100).toFixed(1), '%')

      // Créer le canvas croppé
      croppedCanvas = document.createElement('canvas')
      croppedCanvas.width = bounds.width
      croppedCanvas.height = bounds.height

      const resultCtx = croppedCanvas.getContext('2d')

      // Fond blanc
      resultCtx.fillStyle = '#FFFFFF'
      resultCtx.fillRect(0, 0, bounds.width, bounds.height)

      // Copier la zone
      resultCtx.drawImage(
        canvas,
        bounds.x, bounds.y, bounds.width, bounds.height,
        0, 0, bounds.width, bounds.height,
      )

      console.log('Canvas croppé:', croppedCanvas.width, 'x', croppedCanvas.height)
    } else {
      console.warn('[Crop DOM] Aucun élément visible trouvé, pas de crop')
    }

    console.log('Canvas final:', croppedCanvas.width, 'x', croppedCanvas.height)

    // ===== AJOUTER LE LOGO =====
    console.log('Ajout du logo Gassien...')

    const logo = new Image()
    logo.crossOrigin = 'anonymous'

    await new Promise((resolve) => {
      logo.onload = () => {
        console.log('[Logo] Chargé:', logo.width, 'x', logo.height)

        // Calculer la taille du logo (hauteur = 5% de la hauteur du canvas)
        const logoHeight = Math.floor(croppedCanvas.height * 0.05)
        const logoWidth = Math.floor((logo.width / logo.height) * logoHeight)

        // Espace entre le contenu et le logo
        const spacingY = Math.floor(croppedCanvas.height * 0.03)

        // Créer un nouveau canvas avec espace pour le logo
        const finalCanvas = document.createElement('canvas')
        finalCanvas.width = croppedCanvas.width
        finalCanvas.height = croppedCanvas.height + spacingY + logoHeight + marginPx

        const finalCtx = finalCanvas.getContext('2d')

        // Fond blanc
        finalCtx.fillStyle = '#FFFFFF'
        finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height)

        // Copier le contenu croppé
        finalCtx.drawImage(croppedCanvas, 0, 0)

        // Dessiner le logo centré en bas
        const logoX = (finalCanvas.width - logoWidth) / 2
        const logoY = croppedCanvas.height + spacingY

        finalCtx.drawImage(logo, logoX, logoY, logoWidth, logoHeight)

        console.log('[Logo] Ajouté à la position:', {
          x: logoX.toFixed(0),
          y: logoY.toFixed(0),
          width: logoWidth,
          height: logoHeight,
        })

        // Remplacer le canvas croppé par le canvas final
        croppedCanvas = finalCanvas

        resolve()
      }

      logo.onerror = (err) => {
        console.error('[Logo] Erreur chargement:', err)
        // Continuer sans logo en cas d'erreur
        resolve()
      }

      logo.src = '/wp-content/uploads/2017/01/logo.png'
    })

    console.log('Canvas avec logo:', croppedCanvas.width, 'x', croppedCanvas.height)

    // ===== SAUVEGARDE =====
    croppedCanvas.toBlob((blob) => {
      if (!blob) {
        console.error('Erreur création blob')
        return
      }

      console.log('Blob créé:', (blob.size / 1024 / 1024).toFixed(2), 'MB')

      if (window.showSaveFilePicker) {
        saveWithFileSystemAPI(blob, fileName)
      } else {
        saveWithLegacyMethod(blob, fileName)
      }

      console.log('=== FIN SAUVEGARDE ===')
    }, 'image/png', 1.0)
  } catch (error) {
    console.error('Erreur:', error)
  }
}

const StepTitleSmall = ({ title, content }) => (
  <span className="maker-subtitle-step-small">
    <span>{title}</span>
    <Popover placement="bottom" content={content} title={title} trigger="hover">
      <span style={{ marginLeft: '1em' }}>
        <InfoCircleOutlined />
      </span>
    </Popover>
  </span>
)

const StepTitle = ({ title, content }) => (
  <span className="maker-subtitle-step">
    <span>{title}</span>
    <Popover placement="bottom" content={content} title={title} trigger="hover">
      <span style={{ marginLeft: '1em' }}>
        <InfoCircleOutlined />
      </span>
    </Popover>
  </span>
)

const MakerMenuSmall = ({
  reset,
  setShortkeys,
  setCartVisibility,
  addBox,
  totalPrice,
  currentStep,
  setCurrentStep,
  setShowTuto,
  setModalOpenComposition,
  saveComposition,
  loadingSaveComposition,
}) => {
  const [showCalculatorModal, setShowCalculatorModal] = useState(false)
  const [showBoxModal, setShowBoxModal] = useState(false)

  const ref = useRef(null)

  const { left } = useScroll(ref)


  const maxScroll = ref.current ? ref.current.scrollWidth - ref.current.clientWidth : null

  const scrollLimit = left === 0 ? 'left' : left >= maxScroll - 1 ? 'right' : 'both'

  const SIZE = 'large'

  const styleStep = {
  }

  const setScroll = (direction) => {
    const stepScroll = direction === 'right' ? 100 : -100
    ref.current.scrollLeft += stepScroll
  }

  return (
    <>
      <Row style={{ marginBottom: '10px', fontSize: '0.8em' }}>

        <Col span={4}>
          <Button
            size={SIZE}
            block
            onClick={() => {
              setShowTuto(true)
            }}
          >
            <InfoCircleOutlined />

          </Button>
        </Col>
        <Col span={4}>
          <Button size={SIZE} block onClick={reset}>
            <UndoOutlined />
          </Button>
        </Col>

        <Col span={8}>
          <Button
            size={SIZE}
            block
            onClick={saveComposition}
            disabled={totalPrice === 0}
            loading={loadingSaveComposition}
            icon={<SaveOutlined />}
          >
            {__('Save')}
          </Button>
        </Col>

        <Col span={8}>
          <Button
            size={SIZE}
            block
            onClick={() => {
              setModalOpenComposition(true)
            }}
            icon={<FolderOpenOutlined />}
          >
            {__('Open')}
          </Button>
        </Col>


      </Row>
      <Row>
        <Col
          span={12}
          style={{
            textAlign: 'center',
          }}
        >
          <span style={{ fontSize: '1em', lineHeight: '40px' }} className="configuration-price">
            {totalPrice ? `${formatPrice(totalPrice)}` : '- €'}
          </span>
        </Col>

        <Col span={12} style={{ textAlign: 'right' }}>
          <Button
            type="primary"
            size={SIZE}
            style={{ width: '100%' }}
            onClick={() => { setCartVisibility(true) }}
            disabled={totalPrice === 0}
          >
            {__('Details')}
          </Button>
        </Col>
      </Row>

      <Row style={{ marginTop: '8px', height: '52px' }}>
        <Col span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
          {scrollLimit === 'left' ? null
            : (
              <Button
                block
                type="text"
                size="small"
                style={{
                  padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
                }}
                onClick={() => setScroll('left')}
              >
                <LeftOutlined />
              </Button>
            )}

        </Col>

        <Col offset={1} span={20}>

          <div
            style={{
              overflowX: 'scroll',
              overflowY: 'hidden',
              paddingBottom: '12px',
            }}
            ref={ref}
          >

            <Steps
              current={currentStep}
              onChange={(cur) => setCurrentStep(cur)}
              className="site-navigation-steps-small"
              style={{
                fontSize: '1.2em',
                flexDirection: 'row',
                minHeight: '32px',
              }}
              direction="vertical"
            >
              <Step
                title={<StepTitleSmall title={__('Style')} content={<StyleInfos />} />}
                icon={<Icon component={Empty} />}
                className="step-without-icon"
                style={styleStep}
              />
              <Step
                title={<StepTitleSmall title={__('Wall bases')} content={<WallBasesInfos />} />}
                icon={<Icon component={GridSvg} />}
                style={styleStep}

              />
              <Step
                title={<StepTitleSmall title={__('Boards')} content={<BoardsInfos />} />}
                icon={<Icon component={Board} />}
                style={styleStep}

              />
              <Step
                title={<StepTitleSmall title={__('Accessories')} content={<AccessoriesInfos />} />}
                icon={<Icon component={Hooks} />}
                style={styleStep}
              />
              <Step
                title={<StepTitleSmall title={__('Decor Items')} content={<DecorInfos />} />}
                icon={<Icon component={VaseZenith} />}
                style={styleStep}
              />
            </Steps>
          </div>
        </Col>
        <Col offset={1} span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
          {scrollLimit === 'right' ? null
            : (
              <Button
                block
                type="text"
                size="small"
                style={{
                  padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
                }}
                onClick={() => setScroll('right')}

              >
                <RightOutlined />
              </Button>
            )}


        </Col>

      </Row>

      <BoxModal
        show={showBoxModal}
        addBox={(dim) => { addBox(dim); setShowBoxModal(false); setShortkeys(true) }}
        cancel={() => { setShowBoxModal(false); setShortkeys(true) }}
      />

      <CalculatorModal
        show={showCalculatorModal}
        handleClose={() => setShowCalculatorModal(false)}
      />
    </>
  )
}

const MakerMenu = ({
  reset,
  // setTitle,
  title,
  setShortkeys,
  setCartVisibility,
  addBox,
  selectElement,
  totalPrice,
  currentStep,
  setCurrentStep,
  setShowTuto,
  setModalOpenComposition,
  saveComposition,
  loadingSaveComposition,
}) => {
  const pngFileName = title ? `GASSIEN Paris - ${title}.png` : __('GASSIEN Paris - my composition.png')

  const [showCalculatorModal, setShowCalculatorModal] = useState(false)
  const [showBoxModal, setShowBoxModal] = useState(false)
  const SIZE = 'default'

  return (
    <>
      <Row style={{ marginBottom: '1em' }}>
        <Col span={3}>
          <h1>{__('Configurator')}</h1>
        </Col>
        <Col span={1}>
          <Button type="link" size={SIZE} block onClick={() => setShowTuto(true)}>
            <InfoCircleOutlined />
          </Button>
        </Col>
        <Col span={8}>
          <Row>
            <Col
              offset={2}
              span={10}
              style={{
                textAlign: 'right',
                paddingRight: '1em',
              }}
            >
              <span className="configuration-price">
                {totalPrice ? `TOTAL : ${formatPrice(totalPrice)}` : '- €'}
              </span>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                shape="round"
                style={{ width: '100%' }}
                onClick={() => { setCartVisibility(true) }}
                disabled={totalPrice === 0}
              >
                {__('Details')}
              </Button>
            </Col>

          </Row>
        </Col>
        <Col offset={1} span={11}>
          <Row>
            <Col span={7}>
              <Button
                size={SIZE}
                block
                onClick={() => { track('spaceDimensions'); setShortkeys(false); setShowBoxModal(true) }}
              >
                {__('Space dimensions')}
              </Button>
            </Col>


            <Col offset={1} span={5}>
              <Tooltip placement="bottom" title={__('Save composition')} color={GASSIEN_COLOR}>
                <Button
                  size={SIZE}
                  block
                  onClick={saveComposition}
                  disabled={totalPrice === 0}
                  loading={loadingSaveComposition}
                  icon={<SaveOutlined />}
                >
                  {__('Save')}
                </Button>
              </Tooltip>
            </Col>

            <Col span={5}>
              <Tooltip placement="bottom" title={__('Open composition')} color={GASSIEN_COLOR}>
                <Button
                  size={SIZE}
                  block
                  onClick={() => {
                    setModalOpenComposition(true)
                  }}
                >
                  <FolderOpenOutlined />
                  {__('Open')}
                </Button>
              </Tooltip>
            </Col>

            <Col offset={1} span={2}>
              <Tooltip placement="bottom" title={__('Download image')} color={GASSIEN_COLOR}>
                <Button
                  size={SIZE}
                  block
                  onClick={() => {
                    selectElement(null)
                    saveAsPng('whiteboard', pngFileName)
                  }}
                >
                  <PictureOutlined />
                </Button>
              </Tooltip>
            </Col>
            <Col span={2}>
              <Tooltip placement="bottomLeft" title={__('Reset')} color={GASSIEN_COLOR}>
                <Button size={SIZE} block onClick={reset}>
                  <UndoOutlined />
                </Button>
              </Tooltip>

            </Col>

          </Row>
        </Col>

      </Row>

      <Row style={{ marginBottom: '20px', padding: '0 5%', fontSize: '1em' }}>
        <Steps
          current={currentStep}
          onChange={(cur) => setCurrentStep(cur)}
          className="site-navigation-steps"
          style={{ fontSize: '1em' }}
        >
          <Step
            title={<StepTitle title={__('Style')} content={<StyleInfos />} />}
            icon={<Icon component={Empty} />}
          />
          <Step
            title={<StepTitle title={__('Wall bases')} content={<WallBasesInfos />} />}
            icon={<Icon component={GridSvg} />}
          />
          <Step
            title={<StepTitle title={__('Boards')} content={<BoardsInfos />} />}
            icon={<Icon component={Board} />}
          />
          <Step
            title={<StepTitle title={__('Accessories')} content={<AccessoriesInfos />} />}
            icon={<Icon component={Hooks} />}
          />
          <Step
            title={<StepTitle title={__('Decor Items')} content={<DecorInfos />} />}
            icon={<Icon component={VaseZenith} />}
          />
        </Steps>
      </Row>

      <BoxModal
        show={showBoxModal}
        addBox={(dim) => { addBox(dim); setShowBoxModal(false); setShortkeys(true) }}
        cancel={() => { setShowBoxModal(false); setShortkeys(true) }}
      />

      <CalculatorModal
        show={showCalculatorModal}
        handleClose={() => setShowCalculatorModal(false)}
      />
    </>
  )
}

const MakerContainer = (props) => {
  const isSmall = useIsSmallDevice()
  return isSmall ? <MakerMenuSmall {...props} /> : <MakerMenu {...props} />
}


export default MakerContainer
